import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { colors, css, fonts, glyphs } from "../../../Styles";
import { NumberDisplayList, UNIT, EsfStationEnhanced } from "../..";
import { ListData_ValueTypes, TableStyles_Types } from "../../../Definitions";
import { getCoreRowModel, getFilteredRowModel, getSortedRowModel, useReactTable } from "@tanstack/react-table";
import { ReactiveTable } from "../../Tables/reactiveTableRenderer";
import { EsfLocation } from "../../../Services/Agrisys_GqlDataCaller/WalkThroughDataCalls/getEsfStructureCall";
import { NewButtonList } from "../../BaseComponents/newButton";

// TODO: testdata

interface stationModal_Props {
  // activeSection?: EsfSectionsInfo;
  activeStation?: EsfLocation;
}

export default function EsfStationModal({ activeStation }: stationModal_Props) {
  const { t } = useTranslation();
  const [currentContent, setCurrentContent] = useState<"STATION" | "LAST10DAYS" | "LOG">("STATION");

  // #region | Content Router
  const content_Router = () => {
    switch (currentContent) {
      case "LAST10DAYS":
        return (
          <>Number of feedings and amount of feed last 10 days</>
        )
      case "LOG":
        return (
          <>Last 10 events/eartags</>
        )
      case "STATION":
      default:
        return (<>
          <div style={{marginBottom: "20px", width: "100%"}}> 
            <div style={{ display: "grid", gridTemplateColumns: "50px 1fr 1fr 1fr", gridTemplateRows: "1fr" }}>
              <p style={{ gridArea: "1/1/2/2", ...fonts.header, ...fonts.fontSize4, color: colors.greyDarkPrimary, padding: "0px 16px 2px 16px" }}>{"No."}</p>
              <p style={{ gridArea: "1/2/2/3", ...fonts.header, ...fonts.fontSize4, color: colors.greyDarkPrimary, padding: "0px 16px 2px 16px" }}>{`${t("esfWalkThroughPages.sections.feedMotor", {defaultValue: "feed motor"})}`}</p>
              <p style={{ gridArea: "1/3/2/4", ...fonts.header, ...fonts.fontSize4, color: colors.greyDarkPrimary, padding: "0px 16px 2px 16px" }}>{`${t("esfWalkThroughPages.sections.feedSensor", {defaultValue: "feed sensor"})}`}</p>
              <p style={{ gridArea: "1/4/2/5", ...fonts.header, ...fonts.fontSize4, color: colors.greyDarkPrimary, padding: "0px 16px 2px 16px" }}>{`${t("esfWalkThroughPages.sections.feedComponents", {defaultValue: "feed components"})}`}</p>
            </div>
            {/* {ReactiveTable({table, tableType: TableStyles_Types.noHeaderTable, emptyText: t("feedCurvePages.feedCurve.noComponents", {defaultValue: "No components found"}), renderFooter: false})} */}
          </div>
          <EsfStationEnhanced currentlyAnimal={1000} previouslyAnimal={2000} onClick={() => console.log("gok")} components={true}/>
        </>)
    }
  }
  // #endregion

  // NumberDisplayList: Currently in this station TODO
  const FeedCorrections: JSX.Element = useMemo(() => {
    return (
      <NumberDisplayList
        units={[
          <UNIT content={"Kg"} color={colors.greyPrimary} glyph={<glyphs.Kg size="15px" fillColor={colors.greyPrimary}/>}/>,
          <UNIT content={"Times"} color={colors.greyPrimary}/>
        ]}
        values={[
          0,
          0
        ]}
        headers={["fed today", "uses today"]}
        height="fit-content"
        gridTemplate="'1fr 1fr'"
      />
    )
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [t])

  // #region | Components Table
  // const accessorData = useMemo(() => ([
  //   {headerValue: "", accessor: "feedComponentNumber", type: ListData_ValueTypes.String},
  //   {headerValue: "", accessor: "feedMotor", type: ListData_ValueTypes.String},
  //   {headerValue: "", accessor: "feedSensor", type: ListData_ValueTypes.String},
  //   {headerValue: "", accessor: "feedComponent", type: ListData_ValueTypes.String}
  // ]),[])
  
  // const columns = useEditableColumnConstructor({accessorData, tableStyle: TableStyles_Types.noHeaderTable, canEdit: true });

  // const table = useReactTable({
  //   columns,
  //   data: [],
  //   getCoreRowModel: getCoreRowModel(),
  //   getFilteredRowModel: getFilteredRowModel(),
  //   getSortedRowModel: getSortedRowModel(),
  //   state: {
  //     columnPinning: {
  //       left: ["feedComponentNumber"]
  //     }
  //   },
  // })
  // #endregion

  // Seperator Line
  const seperatorLine = (
    <div style={{ width: "650px", display: "flex", alignItems: "center", justifyContent: "center", margin: "20px auto"}}>
      <div style={{ width: "600px", height: "2px", backgroundColor: colors.greyTertiary}}/>
    </div>
  );
  // #endregion

  return (<>
    <div style={{ ...css.modalTop }}>
      {FeedCorrections}
    </div>
    {seperatorLine}
    <div style={{ display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center", gap: "20px" }}>
      <NewButtonList
        contents={[
          t("esfWalkThroughPages.sections.station", {defaultValue: "station"}),
          t("esfWalkThroughPages.sections.stationLastDays", {defaultValue: "last 10 days"}),
          t("esfWalkThroughPages.sections.stationLog", {defaultValue: "log"}),
        ]}
        onClick={(i) => {
          if (i === 0) { setCurrentContent("STATION") }
          if (i === 1) { setCurrentContent("LAST10DAYS") }
          if (i === 2) { setCurrentContent("LOG")}
        }}
        overrides={{baseStyles: { ...css.button_FitContent }}}
      />
      {content_Router()}
    </div>
  </>)
}